import type { AIModel, AIModelQueryOptions } from '@/types';
import { useInfiniteQuery } from 'react-query';
import { API_ENDPOINTS } from '@/data/client/endpoints';
import client from '@/data/client';
import { useRouter } from 'next/router';
import { getTypeId } from './utils/utils';

export function useAIModels(options?: AIModelQueryOptions) {
  const { locale, query } = useRouter();

  const formattedOptions = {
    ...options,
    language: locale,
    // type_id: types.find((type) => type.slug === query.types)?.id ?? undefined,
    type_id: getTypeId(query.types as string),
  };

  const { data, isLoading, error } = useInfiniteQuery<AIModel[], Error>(
    [API_ENDPOINTS.AI_MODELS, formattedOptions],
    ({ queryKey, pageParam }) =>
      client.aiModels.all(Object.assign({}, queryKey[1], pageParam))
  );

  return {
    aiModels: data?.pages.flatMap((data) => data) ?? [],
    isLoading,
    error,
  };
}
